<!-- <app-loader *ngIf="showSpinner"></app-loader> -->
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4">
    <!-- zeeshan -->
    <div class="evaluation-header">
      <div class="row evaluation-header-inner">
        <div class="col-md-5">
          <div class="evaluation-header-left" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
            @if (evaluations && evaluations.length > 0) {
              <h1>SUMMARY
                <span>{{evaluations[evaluations.length-1].month_char}}
                {{evaluations[evaluations.length-1].month_year}}</span></h1>
              }
            </div>
          </div>
          <div class="col-md-7">
            <div class="evaluation-header-right my-2 my-md-0">
              <!-- <div class="row ">
              <div class="col-sm-8 evaluation-header-right-select " [ngClass]="{ 'dark-background': selectedMode === 'dark' }">
                <select id="month" name="month" class="checks-dropdown form-control selectpicker" ngModel
                  #month="ngModel">
                  <option value="1" selected>January</option>
                  <option value="2">February</option>
                  <option value="3">March</option>
                  <option value="4">April</option>
                  <option value="5">May</option>
                  <option value="6">June</option>
                  <option value="7">July</option>
                  <option value="8">August</option>
                  <option value="9">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                </select>
                <i class="fa fa-chevron-down"></i>
              </div>
              <div class="col-sm-4 evaluation-header-right-button my-3 my-sm-0">
                <button href=" " type="submit" class="btn btn form-control text-white font-weight-bold  apply">
                  Apply
                </button>
              </div>
            </div> -->
          </div>


        </div>
      </div>
    </div>
    <div class="evaluation-graph mt-3">
      <div class="row">
        <div class="col-md-8">
          <div class="evaluation-graph-box px-2 px-sm-4 pt-4 pb-2 mb-2 "
            [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <div class="graph-header pb-3">
              <h1>EVALUATION GARPH</h1>
            </div>
            <div style="height:180px">
              <canvas id="chLine"></canvas>
            </div>

          </div>

        </div>
        <div class="col-md-4">
          <div class="report-inner-section px-2 px-sm-4 py-3 mt-3 mt-md-0"
            [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <div class="report-inner-right-header">
              <div class="inner-right-header-icon">
                <img src="../../../assets/images/signal-icon.svg" alt="">
              </div>
              <div class="inner-right-header-content pl-3">
                <h1>Evaluation</h1>
                <p>{{ evaluations[evaluations.length-1] == null ? "will be uploaded soon!" :
                evaluations[evaluations.length-1].date | date: 'd MMM, y'}}</p>
              </div>

            </div>
            <div class="report-inner-right-tag  pt-4" id="evaluation-zero-hide">
              <div class="inner-left-tag">
                <img src="../../../assets/images/tag-icon.svg" alt="">
              </div>
              <div class="inner-right-tag ">
                <h1>Evaluation</h1>
              </div>

            </div>
            <div class="report-inner-right-tag " id="evaluation-zero-hide-one">
              <div class="inner-left-tag-content">
                <h1>{{ user.first_name }} is a brilliant
                employee of the month.</h1>
              </div>
              <div class="inner-right-tag-content">
                <h1>{{
                  evaluations[evaluations.length-1] == null ? "0" : evaluations[evaluations.length-1].pm_points
                  }} <span>OUT OF 10</span></h1>
                </div>

              </div>
              <div id="evaluation-zero-show">
                <div class="evaluation-zero-section mt-5">
                  <div class="evaluation-zero-image">
                    <img src="../../../assets/images/zero-eva.svg" alt="">
                  </div>

                  <div class="evaluation-zero-status">
                    <div class="inner-right-tag  pb-3">
                      <h1>Evaluation</h1>
                    </div>
                    <div class="inner-right-tag-content pt-3" [ngClass]="{ 'dark-evaluation': selectedMode === 'dark' }">
                      <h1>{{
                        evaluations[evaluations.length-1] == null ? "0" : evaluations[evaluations.length-1].pm_points
                        }} <span>OUT OF 10</span></h1>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="attendance-time-section mt-4 mb-3">
          <div class="row">
            <div class="col-sm-6 col-md-3 col-xl-3 timer">
              <div class="timer-inner my-2 d-flex  flex-row" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                <img class="pr-2" src="../../../assets/images/excellent-tag.svg" alt="">
                <h1 class="pl-2 ">{{ getPointRemarks(showPoints) }}</h1>
              </div>
            </div>
            <div class="col-sm-6 col-md-3 col-xl-3 timer">
              <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                <h1>THIS MONTH
                SATISFACTION</h1>
                <h1>{{monthlyAveragePoints}}%</h1>
              </div>
            </div>
            <div class="col-sm-6 col-md-3 col-xl-3 timer">
              <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                <h1>12 MONTH
                SATISFACTION</h1>
                <h1>{{yearlyAveragePoints}}%</h1>
              </div>
            </div>
            <div class="col-sm-6 col-md-3 col-xl-3 timer">
              <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                <h1>WARNING’S</h1>
                <h1> {{wariningPercentage}}%</h1>
              </div>
            </div>


          </div>
        </div>
        <!-- table -->
        <div class="attendance-report-table mt-4">
          <div class="attendance-report-table-header d-flex justify-content-around px-3">
            <div class="table-heading text-center">Date</div>
            <div class="table-heading text-center">Points</div>
            <div class="table-heading text-center">Status</div>
            <div class="table-heading text-center ">View</div>
          </div>


          @for (evaluation of evaluations; track evaluation; let i = $index) {
            <div class="attendance-report-table-body d-flex justify-content-around px-3 my-4 my-md-0 py-4"
        style="background:{{
        getBackgroundPoint(evaluation.pm_points)
      }}; " [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <div class="table-cotent">
                <div class="table-content-heading">
                  <h1>Date</h1>
                </div>
                <div class="table-content-value">
                  <h1 class="text-md-center"> {{
                    evaluation.year +
                    "/" +
                    evaluation.month +
                    "/" +
                    evaluation.date | date: "dd MMM yyyy"
                  }}</h1>
                </div>
              </div>
              <div class="table-cotent">
                <div class="table-content-heading">
                  <h1>Points</h1>
                </div>
                <div class="table-content-value text-md-center">
                  <h1> {{ evaluation.pm_points }}/10</h1>
                </div>
              </div>
              <div class="table-cotent py-2 py-md-0">
                <div class="table-content-heading">
                  <h1>Status</h1>
                </div>
                <div class="table-content-value text-md-center">
            <h1 style="background-color: {{
            getColorPoint(evaluation.pm_points)
          }};border:1px solid {{
            getBorderPoint(evaluation.pm_points)
          }};color:{{
            getBorderPoint(evaluation.pm_points)
          }}">{{ getPointRemarks(evaluation.pm_points) }}</h1>
                </div>
              </div>
              <div class="table-cotent">
                <div class="table-content-heading">
                  <h1>View</h1>
                </div>
                <div class="table-content-value text-md-center">
                  <img (click)="showdata(evaluations[i])" class="pr-2" src="../../../assets/images/eye.png" alt=""
                    style="cursor: pointer;">
                  </div>
                </div>
              </div>
            }


          </div>
        </div>
      </main>